import {
  makeCreateWidgetAction,
  type MakeCreateWidgetActionDeps,
  type WidgetActionProcessor,
  type WidgetActionSchema,
} from '@/entities/widget';
import { SocialBriefWidgetType } from '@inference.engine/widgets';
import { SocialBriefWidgetKey } from '@inference.engine/widgets/web';

/**
 * Factory that binds the SocialBriefWidget processor to the supplied dep
 * surface. Returns the processor list consumed by the central widget
 * dispatcher in `features/widgets/processors/`.
 *
 * The widget slice MUST NOT value-import `widgetProcessorDeps` from
 * `@/features/widgets/processors/...`. The dispatcher binds with deps once.
 */
export const makeProcessors = (deps: MakeCreateWidgetActionDeps): WidgetActionProcessor[] => {
  const create: WidgetActionProcessor<WidgetActionSchema<SocialBriefWidgetType>> = {
    key: SocialBriefWidgetKey,
    processor: makeCreateWidgetAction(deps) as WidgetActionProcessor<
      WidgetActionSchema<SocialBriefWidgetType>
    >['processor'],
  };
  return [create];
};
